<script lang="ts">
	import Arrow from './arrow.svg.svelte';

	interface Props {
		sort?: 'asc' | 'desc' | null;
		className?: string;
	}

	let { sort = $bindable(null), className = '' }: Props = $props();

	function toggle() {
		if (sort === 'asc') {
			sort = 'desc';
		} else if (sort === 'desc') {
			sort = null;
		} else {
			sort = 'asc';
		}
	}
</script>

<div class={className}>
	<button class="w-full flex items-center" onclick={toggle}>
		<div class="w-12 rotate-180 {sort == 'desc' ? 'invisible' : ''} -mx-1"><Arrow /></div>
		<div class="w-12 {sort == 'asc' ? 'invisible' : ''} -mx-1"><Arrow /></div>
	</button>
</div>
